import React, { useEffect, useState } from "react";
import { message, Layout, Modal, Button, } from "antd";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { LoadingOutlined } from "@ant-design/icons";
import logo from "./../assets/img/BAbianco.png"
import { checkTokenOperatore } from "../services/api";
import { CONFIG } from '../services/config';

const { Content, Header } = Layout;
const { innerWidth, innerHeight } = window;

const DialogInattività = ({ showDialogInattivita, setShowDialogInattivita, secondsTimeout, setSecondsTimeout }) => {

  const handleClose = () => {
    setSecondsTimeout(CONFIG.TOTEM_TIMEOUT_SECONDS);
    setShowDialogInattivita(false);
  };

  return (
    <Modal cancelText={'Prova'} okText={'Riprendi'} open={showDialogInattivita} onCancel={handleClose} 
    footer={[
      <Button key="submit" type="primary" onClick={handleClose}>
        Riprendi
      </Button>,
    ]}>
      <div style={{ fontFamily: 'Poppins-SemiBold', fontSize: 16, maxHeight: '70vh', overflowY: 'auto' }}>
        <div style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 20 : 30 }}>
          La pratica si chiuderà per inattività tra
        </div>
        <div style={{ color: '#003897', fontFamily: 'Poppins-SemiBold', fontSize: innerWidth < 500 ? 16 : 20 }}>
          {secondsTimeout} secondi
        </div>
      </div>
    </Modal>

  );
};

export default DialogInattività;
